import React, { useRef, useState } from "react";
import { auth, RecaptchaVerifier, signInWithPhoneNumber } from "../services/firebase";
import apis from "../api";

const PhoneAuth = () => {
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [confirmation, setConfirmation] = useState(null);
  const [mailConfirmation, setMailConfirmation] = useState(false)
  const [mailOtp, setMailOtp] = useState("")
  const [isOpenOtp, setIsOpenOtp] = useState(false)
  const [loadOtp, setLoadOtp] = useState(false)
  const [loadVerify, setLoadVerify] = useState(false)
  const [isValid, setIsValid] = useState(false)
  const [captchaKey, setCaptchaKey] = useState(0)
  const toastOtp = useRef(null)

  const headers = {
    authorization: localStorage.getItem('token')
  }

  // Initialize reCAPTCHA
  const setupRecaptcha = () => {
    // Check if recaptchaVerifier already exists
    if (window.recaptchaVerifier) {
      console.log("⚠️ Clearing previous reCAPTCHA instance...");
      window.recaptchaVerifier.clear();
      window.recaptchaVerifier = null;
    }

    // Ensure recaptcha-container is empty
    const recaptchaContainer = document.getElementById("recaptcha-container");
    if (recaptchaContainer) {
      recaptchaContainer.innerHTML = ""; // Force re-render
    }

    // Create a new reCAPTCHA instance
    window.recaptchaVerifier = new RecaptchaVerifier(auth, "recaptcha-container", {
      size: "invisible",
      callback: (response) => {
        console.log("✅ reCAPTCHA solved", response);
      },
      "expired-callback": () => {
        console.log("⚠️ reCAPTCHA expired, resetting...");
        setupRecaptcha(); // Automatically recreate if expired
      },
    });

    console.log("🎯 reCAPTCHA initialized");
  };

  const resetRecaptcha = () => {
    if (window.recaptchaVerifier) {
      window.recaptchaVerifier.clear(); // Fully remove previous reCAPTCHA
      window.recaptchaVerifier = null;
    }
  };

  // Send OTP
  const sendOtp = async () => {
    setLoadOtp(true)
    setupRecaptcha();
    let newPhone = '+57' + phone
    let appVerifier = window.recaptchaVerifier;
    try {
      const confirmationResult = await signInWithPhoneNumber(auth, newPhone, appVerifier);
      setConfirmation(confirmationResult);
      toastOtp.current.show({ severity: 'success', summary: 'Éxito', detail: `Código de verificación enviado` });
    } catch (error) {
      console.error(error.code);
      let errorMessage = 'Error'
      switch (error.code) {
        case "auth/invalid-verification-code":
          errorMessage = "El código ingresado es incorrecto.";
          break;
        case "auth/code-expired":
          errorMessage = "El código ha expirado. Solicite uno nuevo.";
          break;
        case "auth/too-many-requests":
          errorMessage = "Demasiados intentos. Espere unos minutos antes de intentarlo nuevamente.";
          break;
        default:
          errorMessage = "Error: " + error.message;
      }
      console.log(errorMessage)
      if(errorMessage.includes('reCAPTCHA')){
        errorMessage = 'Error: Error de reCAPTCHA. Intente nuevamente'
      }
      toastOtp.current.show({ severity: 'warn', summary: 'Aviso', detail: errorMessage, sticky: true });
      // window.recaptchaVerifier.clear()
      // window.recaptchaVerifier = null
      setCaptchaKey((prev) => prev + 1)
    }
    finally {
      setLoadOtp(false)
    }
  };

  // Verify OTP
  const verifyOtp = async () => {
    setLoadVerify(true)
    if (!confirmation) {
      return toastOtp.current.show({ severity: 'warn', summary: 'Éxito', detail: `Solicite un código de verificación primero` });;
    }
    try {
      await confirmation.confirm(otp);
      toastOtp.current.show({ severity: 'success', summary: 'Éxito', detail: `Verificación exitosa` });
      setIsValid(true)
      // setTimeout(() => {
      //     setIsOpenOtp(false)
      //   }, 2000)
    } catch (error) {
      console.error(error);
      let errorMessage = 'Error'
      switch (error.code) {
        case "auth/invalid-verification-code":
          errorMessage = "El código ingresado es incorrecto.";
          break;
        case "auth/code-expired":
          errorMessage = "El código ha expirado. Solicite uno nuevo.";
          break;
        case "auth/too-many-requests":
          errorMessage = "Demasiados intentos. Espere unos minutos antes de intentarlo nuevamente.";
          break;
        default:
          errorMessage = "Error: " + error.message;
      }
      console.log(errorMessage)
      if(errorMessage.includes('reCAPTCHA')){
        errorMessage = 'Error: Error de reCAPTCHA. Intente nuevamente'
      }
      toastOtp.current.show({ severity: 'warn', summary: 'Aviso', detail: errorMessage, sticky: true });
    }
    finally {
      setLoadVerify(false)
    }
  };

  const sendMailOtp = async () => {
    setLoadOtp(true)
    try {
      await apis.getVerificationCode(headers).then(res => {
        setMailConfirmation(true);
        toastOtp.current.show({ severity: 'success', summary: 'Éxito', detail: `Código de verificación enviado` });
      })
    }
    catch (err) {
      console.error(err);
      toastOtp.current.show({ severity: 'warn', summary: 'Aviso', detail: `Fallo al enviar Código de verificación: ${err.response.data.message}`, sticky: true });
    }
    finally {
      setLoadOtp(false)
    }
  }

  const verifyMailOtp = async () => {
    setLoadVerify(true)
    const payload = {
      CODE: mailOtp
    }
    try {
      await apis.postVerificationCode(payload, headers).then(res => {
        toastOtp.current.show({ severity: 'success', summary: 'Éxito', detail: `Verificación exitosa` });
        setIsValid(true)
        // setTimeout(() => {
        //   setIsOpenOtp(false)
        // }, 2000)
      })
    }
    catch (err) {
      console.error(err);
      toastOtp.current.show({ severity: 'warn', summary: 'Aviso', detail: `Código de verificación inválido: ${err.response.data.message}`, sticky: true });
    }
    finally {
      setLoadVerify(false)
    }
  }

  return {
    phone, setPhone, otp, setOtp, confirmation, setConfirmation, sendOtp, verifyOtp, toastOtp, isOpenOtp,
    setIsOpenOtp, mailConfirmation, setMailConfirmation, mailOtp, setMailOtp, verifyMailOtp, sendMailOtp,
    loadVerify, setLoadVerify, loadOtp, setLoadOtp, isValid, setIsValid, captchaKey
  };
};

export default PhoneAuth;